import { render, staticRenderFns } from "./CatalogoWeb.vue?vue&type=template&id=154cdc2d&scoped=true"
import script from "./CatalogoWeb.vue?vue&type=script&lang=js"
export * from "./CatalogoWeb.vue?vue&type=script&lang=js"
import style0 from "./CatalogoWeb.vue?vue&type=style&index=0&id=154cdc2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154cdc2d",
  null
  
)

export default component.exports